module.exports = "/fast-coin/img/coin/anim/in/coin_in_020.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_020.png
// module id = 2290
// module chunks = 5